// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {Modal} from '../../../../shared/ui/modal';
import {Button} from '../../../../shared/button';
import styles from './styles.module.less';

interface i_settlement_done_popup_props {
    is_open: boolean;
    on_close: ()=>void;
    on_got_it: ()=>void;
    is_client: boolean;
    benefit_value?: string;
}

export const Settlement_done_popup = (props:
    i_settlement_done_popup_props)=>{
    const {is_open, on_close, on_got_it, is_client, benefit_value} = props;
    if (!is_client)
        return null;
    const get_benefit_text = ()=>{
        if (benefit_value=='refund')
            return 'settlement benefit refund';
        if (benefit_value=='membership')
            return 'settlement benefit of free Hola Watch Time';
        return 'settlement benefit';
    };
    return <Modal is_open={is_open} on_close={on_close}
      paddingless no_logo width={468}>
      <div className={cn(styles.settlement_done_popup)}>
        <div className={cn(styles.content_section)}>
          <div className={cn(styles.title_and_content)}>
            <div className={cn(styles.title)}>
              Benefit Already Received
            </div>
            <div className={cn(styles.content)}>
              Dear Hola user, you have already received your
              {' '}{get_benefit_text()}. Thank you for being part of the
              Hola community.
            </div>
            <div className={styles.button_wrapper}>
              <Button caption={'Got it'}
                size="md" round on_click={on_got_it}
                cls={styles.button}/>
            </div>
          </div>
        </div>
      </div>
    </Modal>;
};
